export default __webpack_public_path__ + "static/media/redux_Logo.4db4d18d.png";